import { generatePath } from "react-router-dom";
import { SIGNUP_DEPRECATED_UID_PATH } from "view/routes";

const generateSignUpUrl = (showId: string, token?: string) => {
  if (!token) {
    return "";
  }
  const pathname = generatePath(SIGNUP_DEPRECATED_UID_PATH, { uid: token });
  return `${window.location.origin}${pathname}?showId=${showId}`;
};
export default generateSignUpUrl;
